import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { DeviceConnectivityModuleSettings } from '../models/device-connectivity-module-settings.model';
import { AbstractDeviceConnectivityModuleService } from '../services/abstract-device-connectivity-module.service';

export const DEVICE_CONNECTIVITY_MODULE_SETTINGS = new InjectionToken<DeviceConnectivityModuleSettings>('DEVICE_CONNECTIVITY_MODULE_SETTINGS');

const getDeviceConnectivityModuleProviders = (settings: DeviceConnectivityModuleSettings) => [
  { provide: DEVICE_CONNECTIVITY_MODULE_SETTINGS, useValue: settings },
  { provide: AbstractDeviceConnectivityModuleService, useClass: settings.deviceConnectivityModuleService }
];

// Used for lazy loading in a specific module
export function provideDeviceConnectivityModuleSettings(settings: DeviceConnectivityModuleSettings): EnvironmentProviders {
  return makeEnvironmentProviders([...getDeviceConnectivityModuleProviders(settings)]);
}
